import { Component, input } from '@angular/core';
import { RecapSection } from 'src/app/models/vehicle-order-quote.model';
export { RecapItem, RecapSection } from 'src/app/models/vehicle-order-quote.model';

@Component({
  selector: 'app-quote-recap-content',
  templateUrl: './quote-recap-content.component.html',
  styleUrls: ['./quote-recap-content.component.scss'],
  standalone: false
})
export class QuoteRecapContentComponent {
  recapSections = input.required<RecapSection[]>();
  details = input<{ section: string; rows: { key: string; value: string | number | null }[] }[]>();
}
